import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QAQuestionEntity from "../../../../domain/entities/qa_question.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QAQuestionDto from "../../../dto/qa_question.dto";
import QACategoryEntity from "../../../../domain/entities/qa_category.entity";
import { category } from "fp-ts";

const createQuestionApiImpl = async (_:{ category: QACategoryEntity, question: QAQuestionEntity }): Promise<Either<ErrorEntity, QAQuestionEntity>> => {
    try {
        const relativeUrl = "/question";
        const body = QAQuestionDto.toJSON(_.question);
        body['category_id'] = parseInt(_.category.id.toString());
        body['agent_id'] = parseInt((_.category.agentId ?? _.question.agentId).toString());
        //remove id from bod
        console.log("body create questionnn", {body, category: _.category, question: _.question});
        const response = await di.get<HostApi>(HostApiName).post(relativeUrl, body, { contentType: 'application/json' });
        const parsed = QAQuestionDto.fromJSON(response);
        parsed.agentId = _.category.agentId ?? _.question.agentId;
        console.log("response create questionnn", {response, parsed});
        return right(parsed);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default createQuestionApiImpl;